export const SET_TRACKED_EVENT_DATA = "SET_TRACKED_EVENT_DATA";
export const CLEAR_TRACKED_EVENT_DATA = "CLEAR_TRACKED_EVENT_DATA";

export const SET_SYNCED_EVENTS_DATA = "SET_SYNCED_EVENTS_DATA";
